function removeListener(element, eventName, fnName) {
  const normalElement = element;
  const operaElement = element;
  if (normalElement.removeEventListener) {
    normalElement.removeEventListener(eventName, fnName, false);
  } else if (operaElement.detachEvent) {
    operaElement.detachEvent("on".concat(eventName), fnName);
  }
}
export default removeListener;